export const RESET = 'CONFACL_UPDATE_RESET'
export const SET_ERROR = 'CONFACL_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CONFACL_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CONFACL_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CONFACL_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CONFACL_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CONFACL_UPDATE_UPDATE_RETRIEVED'
